export default {"src":"/_next/static/media/pos_original.c08519a3.svg","height":1470,"width":800,"blurWidth":0,"blurHeight":0};